/**
 * PageSpinner — full-page loading spinner.
 *
 * Centered horizontally within the main content column (offset for the
 * 73px sidebar) and vertically in the viewport. Use when waiting for
 * a primary page resource to load.
 */
export function PageSpinner() {
  return (
    <div className="fixed inset-y-0 left-[73px] right-0 flex items-center justify-center pointer-events-none">
      <svg
        className="animate-spin h-14 w-14 text-primary"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        role="img"
        aria-label="Loading"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          className="opacity-90"
          d="M22 12a10 10 0 00-10-10"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}
